import { SxProps, Typography, useTheme } from '@mui/material';
import { FunctionComponent, PropsWithChildren } from 'react';
import { mergeSx } from '../../util/Styles';

type Props = PropsWithChildren<{
	sx?: SxProps;
}>;

export const KeyLabel: FunctionComponent<Props> = (props) => {
	const theme = useTheme();

	return <Typography sx={mergeSx({
		marginLeft: 2,
		paddingX: 1,
		paddingY: 0.5,
		bgcolor: theme.palette.grey[200],
		borderRadius: '4px',
		fontSize: '0.75rem',
		fontWeight: 'bold',
		fontFamily: 'monospace',
	}, props.sx)}>
		{props.children}
	</Typography>;
};